import { render, staticRenderFns } from "./CompAdd.vue?vue&type=template&id=533fbb0e"
import script from "./CompAdd.vue?vue&type=script&lang=js"
export * from "./CompAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports